
import { writable } from "svelte/store";

export const modalStore = writable({
    title: "",
    body: "",
    link: "",
    linkText: "",
});

export const triggerModal = ({title = "", body = "", link = "", linkText = ""}) => {
    modalStore.set({
        title,
        body,
        link,
        linkText,
    });
}

export const clearModal = () => {
    modalStore.set({
        title: "",
        body: "",
        link: "",
        linkText: "",
    });
}
